import {Component} from '@angular/core'

@Component({
  selector: 'spb-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrls: ['./chart-legend.component.scss']
})
export class ChartLegendComponent {
}
